import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { HttpService } from '../services/http.service';

@Component({
  selector: 'app-virtual-scroll',
  templateUrl: './virtual-scroll.component.html',
  styleUrls: ['./virtual-scroll.component.css'],
})
export class VirtualScrollComponent {
  @Input() apiUrl: string;
  @Input() data: any={};
  @Input() outcome_status: any;
  @Input() itemSize: number = 10;
  @Output() loadedData = new EventEmitter<any[]>();
  httpService = inject(HttpService);
  items: any[] = [];
  loading: boolean = false;
  page: number = 1;
  totalPages: number = 0;

  fetchItems() {
    if (
      this.loading ||
      (this.totalPages && this.items?.length == this.totalPages)
    ) {
      return;
    }

    this.loading = true;
    this.httpService.post(this.apiUrl, { page: this.page, ...this.data ,...this.outcome_status}).subscribe((res: any) => {
      this.items = [...this.items, ...(res?.data ?? [])];
      this.totalPages = res?.count;
      this.loading = false;
      this.page++;
      this.loadedData.emit(this.items);
    });
  }

  onScroll() {
    const container = document.querySelector('.infinite-scroll-container')!;
    if (
      container.scrollHeight - container.scrollTop <=
      container.clientHeight + 100
    ) {
      if (!this.loading) {
        this.fetchItems();
      }
    }
  }
}
